import { CONSOLE_ONLY_ERRORS } from 'shared/config';

// Оставляет в консоли только console.error (настраивается в shared/config).
export const silenceConsole = () => {
  if (!CONSOLE_ONLY_ERRORS) return;
  const noop = () => {};
  ['log', 'info', 'warn', 'debug', 'trace'].forEach((method) => {
    console[method] = noop;
  });
};
